import _ from 'lodash';
const initialState ={
  result:{},
  formbuilder:{}
}
export default (state = initialState, action) => {
  let elements={}
  let newState =  _.cloneDeep(state.result)
  let newStateTemplate =  _.cloneDeep(state.formbuilder)
  switch (action.type) {
   case "FORM_ELEMENTS_ACTION":
    let sortOrder = ["Parameters", "Attributes", "Questions", "NC Reason 1", "NC Reason 2", "NC Reason 3", "NC Reason 4", "NC Reason 5", "Addtional Fields"];
    _.map(sortOrder, (obj) =>{ elements={...elements, [obj]:action.payload[obj]} } )
    return Object.assign({}, state, {
      result: elements,
      isPending:action.isPending
   })
    case "FORM_ELEMENTS_ACTION_ADD":
      newState[action.prop].push(action.obj);
      return Object.assign({}, state, {
        result: newState
    })
    case "FORM_ELEMENTS_ACTION_DELETE":
        let x1 = _.find(newState[action.prop], action.obj);
        x1.status = 'INACTIVE'        
        return Object.assign({}, state, {
          result: newState
    })  
    case "FORM_ELEMENTS_ACTION_EDIT":
        let x = _.find(newState[action.prop], action.object);
        x.label = action.data
      return Object.assign({}, state, {
      result: newState
    })    
    case "FORM_TEMPLATE_UPDATEERROR":
     return Object.assign({}, state, {
        errmessage: action.errmessage,
        showerror: action.showerror,
        isPending:action.isPending
   })  
    case "FORM_ELEMENTS_ACTION_ADDITIONALFIELD_EDIT":
         var id = action.obj.id
         var index = newState[action.prop].findIndex(item => item.id === id)
         newState[action.prop].splice(index, 1, action.obj)
        return Object.assign({}, state, {
          result: newState
        }) 
    case "FORM_ELEMENTS_ACTION_ACTIVE":
        let active = _.find(newState[action.prop], action.obj);
        active.status = 'ACTIVE' 
    return Object.assign({}, state, {
      result: newState
    })  
    case "FORM_TEMPLATE_ACTION": 
    return Object.assign({}, state, {
      formbuilder: action.payload,
      isPending:action.isPending
    })  
    case "FORM_TEMPLATE_ACTION_ADD":
        newStateTemplate.push(action.Object)
      return Object.assign({}, state, {
        formbuilder: newStateTemplate,
        isPending:action.isPending
    })
    case "FORM_TEMPLATE_ACTION_EDIT":
        let newtemp = _.find(newStateTemplate, {'templateName':action.title})       
        newtemp.templateValue = action.prop
      return Object.assign({}, state, {
        formbuilder: newStateTemplate,
        isPending:action.isPending
    })  
    case "FORM_PENDING":
      return Object.assign({}, state, {
        isPending: action.isPending
    }) 
    case "FORM_TEMPLATE_ACTION_INACTIVE":
      return Object.assign({}, state, {
        formbuilder: action.payload
    }) 
    case "FORM_TEMPLATE_INVENTORY_ACTION":
      return Object.assign({}, state, {
        inventory: action.payload
    })  
    case "FORM_TEMPLATE_TEMPLATE_MAPPING":
      return Object.assign({}, state, {
        template: action.payload
    }) 
    case "FORM_TEMPLATE_MAP":
      return Object.assign({}, state, {
      mapSucess: action.mapSucess.value
    })
    case "FORM_TEMPLATE_MAPPED_LIST":
      return Object.assign({}, state, {
        mappedData: action.mappedData,
        isPending:action.isPending
    })
    case "FORM_TEMPLATE_NAMES_LIST":
      let newNameList = action.nameList
         _.remove(newNameList, { templateName: "Default Template"})
        return Object.assign({}, state, {
          templateNameList: newNameList
      })
    case "FORM_TEMPLATE_AUDIT_TYPES":
        return Object.assign({}, state, {
          auditTypes: action.auditTypes
      })
    case "FORM_TEMPLATE_DELETE":
        let newdel = _.find(newStateTemplate, {'templateName':action.prop.templateName})  
        _.pull(newStateTemplate, newdel)
        return Object.assign({}, state, {
          formbuilder: newStateTemplate
      })
    case "FORM_ACTION_MODAL_CLOSE": 
      return Object.assign({}, state, {
        showerror: action.showerror
    }) 
   default:
    return state
  }
 }

 